import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import "./Scrollbar.css";

const MultiSelect = ({
  title,
  data = [], // Default to an empty array
  selectedFields,
  setSelectedFields,
  field,
  errors,
  setErrors,
}) => {
  const handleFieldChange = (event) => {
    const { value, checked } = event.target;

    // Clear the error for the specific field
    setErrors((prev) => ({
      ...prev,
      [title]: "", // Clear the error for the specific field
    }));

    // Use a function to update the state based on the previous state
    setSelectedFields((prevState) => {
      // Ensure the field exists and is an array
      const updatedSelection = checked
        ? [...(prevState[field] || []), value] // Add value to the array
        : (prevState[field] || []).filter((item) => item !== value); // Remove value from the array

      // Return the updated state with the updated field
      return {
        ...prevState,
        [field]: updatedSelection, // Update the field with the selected items array
      };
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "320px",
        flexDirection: "column",
        ml: 1,
        maxHeight: "90%",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{ fontWeight: "bold", marginBottom: "30px" }}
      >
        {title}
      </Typography>
      <Box className="scrollable-container">
        {data && data.length > 0 ? (
          data.map((Field, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={Field}
                  checked={
                    Array.isArray(selectedFields?.[field]) &&
                    selectedFields[field]?.includes(Field) // Ensure it's an array and includes the item
                  }
                  onChange={handleFieldChange}
                />
              }
              label={Field}
            />
          ))
        ) : (
          <Typography>No options available</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default MultiSelect;
